import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { Filter, FilterOperation, HasFilter } from 'src/app/core/jsonapi/filter';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { TransactionsService } from '../_services/transactions.service';
import { TransactionsTypesService } from '../_services/transactions-types.service';
import { ThirdPartiesService } from '../_services/third-parties.service';
import { AffectedsService } from '../../cases/_services/affecteds.service';
import { TransactionsStatesService } from '../_services/transactions-states.service';
import { Business } from '../../business/_types/business';
import { BusinessService } from '../../business/_services/business.service';
import { Transaction } from '../_types/transaction';
import { TemplatesService } from '../../templates/_services/templates.service';
import { Tax } from '../../taxes/_types/tax';
import { TaxesService } from '../../taxes/_services/taxes.service';
import { TransactionsLinesService } from '../_services/transactions-lines.service';
import { PaymentsMethodsService } from '../../common/_services/payments-methods.service';
import { PaymentMethod } from '../../common/_types/payment-method';
import { BusinessBankAccount } from '../../business/_types/business-bank-account';
import { BusinessBankAccountsService } from '../../business/_services/business-bank-accounts.service';
import { CasesService } from '../../cases/_services/cases.service';
import { date } from '@rxweb/reactive-form-validators';
import { Contract } from '../../companies/_types/contract';
import { ContractTransactionSeriesService } from '../../companies/_services/contracts-transactions-series.service';
import { WorkersService } from '../../workers/_services/workers.service';
import { TransactionsRevisionsReasonsService } from '../_services/transactions-revision-reasons.service';
import { DialogService } from 'primeng/dynamicdialog';
import { GenerateInvoiceComponent } from '../generate-invoice/generate-invoice.component';
import { GenerateInvoiceCsvComponent } from '../generate-invoice-csv/generate-invoice-csv.component';
import { LoginService } from '../../login/login.service';
import { SessionStorageService } from 'angular-web-storage';
import { UsersService } from '../../users/_services/users.service';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';

type FilterOption = { label: string; value: any };

@Component({
    selector: 'app-transactions-list',
    templateUrl: './transactions-list.component.html',
    styleUrls: ['./transactions-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'list-page' },
    standalone: false
})
export class TransactionsListComponent implements OnInit {
  public transactions: any = [];
  public transactionType: any = {};
  public totalRecords: number = 0;
  public loading: boolean = false;
  public type!: string;
  public typeSelected: any = {};
  private lastGridEvent: any;
  
  public allFilters: any = [];
  public filtersDate: any = {};
  public filters: any = {
    code: new Filter(FilterOperation.contains, 'code'),
    thirdPartyId: new Filter(FilterOperation.equals, 'thirdPartyId'),
    transactionStateId: new Filter(FilterOperation.equals, 'transactionStateId'),
    businessId: new Filter(FilterOperation.equals, 'businessId'),
    dateFrom: new Filter(FilterOperation.greaterOrEqual, 'date'),
    dateTo: new Filter(FilterOperation.lessOrEqual, 'date'),
    caseNumber: new Filter(FilterOperation.contains, 'case.caseNumber'),
    caseNotificationNumber: new HasFilter('case.caseNotificationNumbers', new Filter(FilterOperation.contains, 'code')),
    netSuiteId: new Filter(FilterOperation.equals, 'netSuiteId', '', null, false),
    //processorId: new Filter(FilterOperation.equals, 'case.processorId')
    originalProcessorId: new Filter(FilterOperation.equals, 'originalProcessorId'),
    thirdPartyName: new Filter(FilterOperation.contains, 'thirdParty.name')
  };
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public allowRowSelection: boolean = false;
  public selectedRowsIds: any[] = [];  
  public selectionCollapsedByUser: boolean | null = null;
  public displayModal: boolean = false;
  public thirdParties: any = [];
  public thirdPartyName: string = "Tercero";
  public transactionStates: any = [];
  public business: Array<Business> = new Array<Business>;  
  public displayPaymentModal: boolean = false;
  public displayReviewModal: boolean = false;
  public payment: any = {};
  public transactionSelected: any = {};
  public caseSelected: any = {};
  public taxes: Tax[] = [];
  public loadingTaxes: boolean = false;
  public paymentsMethods: Array<PaymentMethod> = new Array<PaymentMethod>();
  public billingCompaniesBanksAccounts: Array<BusinessBankAccount> = new Array<BusinessBankAccount>();  
  public invoice: any = {
    date: new Date(),
    isPayed: false,
  };
  //public selectedPaymentMethodRequiresBank: boolean = false;
  public transactionSeries: any = [];
  public workers: any = [];  
  public request: any = {};
  public displayRequestModal: boolean = false;
  public notPayed: boolean = false;
  public today = new Date();
  public soon = new Date();
  public transactionRevisionReasons: any = [];
  private hasFiltersInUrl: boolean = false;
  public processors: any = [];
  public typesPayment: any[] = [{ name: 'Total', id: 'total' }, { name: 'Parcial', id: 'partial' }]
  public transactionsLinesToPayment: any[]=[];
  public selectedTransactionLinesToPayment: any[]=[];

  public chips = {
    code: new Filter(FilterOperation.contains, 'code'),
    thirdPartyName: new Filter(FilterOperation.contains, 'thirdParty.name'),
    transactionStateId: new Filter(FilterOperation.equals, 'transactionStateId'),
    businessId: new Filter(FilterOperation.equals, 'businessId'),
    dateFrom: new Filter(FilterOperation.greaterOrEqual, 'date'),
    dateTo: new Filter(FilterOperation.lessOrEqual, 'date'),
    caseNumber: new Filter(FilterOperation.contains, 'case.caseNumber'),
    notificationNumber: new Filter(FilterOperation.contains, 'code'),
    dueFrom: new Filter(FilterOperation.greaterOrEqual, 'paymentDuedate'),
    dueTo: new Filter(FilterOperation.lessOrEqual, 'paymentDuedate'),
    notLinked: new Filter(FilterOperation.equals, 'netSuiteId'),
    processorId: new Filter(FilterOperation.equals, 'originalProcessorId')
  };
  public stateOptions: FilterOption[] = [];
  public businessOptions: FilterOption[] = [];
  public processorOptions: FilterOption[] = [];
  private allFieldsConfig: FilterFieldConfig[] = [
    { filter: this.chips.thirdPartyName, type: 'text', label: 'Tercero', base: true },
    { filter: this.chips.transactionStateId, type: 'select', label: 'Estado', options: this.stateOptions, filterable: true, base: true },
    { filter: this.chips.businessId, type: 'select', label: 'Sociedad', options: this.businessOptions, filterable: true, base: true },
    { filter: this.chips.dateFrom, filterTo: this.chips.dateTo, type: 'date', label: 'Fecha', base: true },
    { filter: this.chips.caseNumber, type: 'text', label: 'Expediente' },
    { filter: this.chips.notificationNumber, type: 'text', label: 'Nº servicio' },
    { filter: this.chips.dueFrom, filterTo: this.chips.dueTo, type: 'date', label: 'Vencimiento' },
    { filter: this.chips.notLinked, type: 'bool', label: 'No enlazados' },
    { filter: this.chips.processorId, type: 'select', label: 'Tramitador', options: this.processorOptions, filterable: true }
  ];
  public fieldsConfig: FilterFieldConfig[] = [...this.allFieldsConfig];

  constructor(
    private dialogService: DialogService,
    private transactionsService: TransactionsService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public topbarService: TopbarService,
    private transactionsTypesService: TransactionsTypesService,
    private thirdPartiesService: ThirdPartiesService,
    private affectedsService: AffectedsService,
    private transactionsStatesService: TransactionsStatesService,
    private businessService: BusinessService,
    private templateService: TemplatesService,
    private taxesService: TaxesService,
    private transactionsLinesService: TransactionsLinesService,
    private casesService: CasesService,
    private workersService: WorkersService,
    private transactionsRevisionsReasonsService: TransactionsRevisionsReasonsService,
    public loginService: LoginService,
    private sessionStorage: SessionStorageService,
    private usersService: UsersService
  ) {

    this.allowWrite = true;
    this.allowDelete = true;

    this.notPayed = this.route.snapshot.queryParamMap.get('notPayed') === 'true';
    if(this.notPayed){      
      this.soon.setDate(this.today.getDate() + 5);
      this.filtersDate.paymentDuedateTo = this.soon;
      this.hasFiltersInUrl = true;
      //this.filters.transactionStateId = new Filter(FilterOperation.equals, 'transactionState.code', '', "pending");
    }    
  }

  ngOnInit(): void {

    this.filters.transactionStateId.value = this.route.snapshot.queryParamMap.get('transactionStateId');
    if(this.filters.transactionStateId.value){
      this.hasFiltersInUrl = true;
    }

    
  
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.type = params.get('type') ?? '';
      
      //recuperar filtros guardados
      let savedFilters = this.sessionStorage.get("transactionFilters_" + this.type);
      if (savedFilters != null && !this.hasFiltersInUrl){
        FilterBuilder.loadSavedFilters(this.filters, savedFilters);
        this.allFilters[this.type] = this.filters;
      }
      let saveFiltersDate = this.sessionStorage.get("transactionFiltersDate_" + this.type);
      if (saveFiltersDate != null && !this.hasFiltersInUrl){
        Object.keys(saveFiltersDate).forEach((key) => {
          const value = saveFiltersDate[key as keyof typeof saveFiltersDate];
          if (value) this.filtersDate[key] = new Date(value);
        });
       // this.filtersDate = saveFiltersDate;
      }

      //comprobamos permisos
      this.allowWrite = this.loginService.hasPermission(this.type.toUpperCase() + ".WRITE");
      this.allowDelete = this.loginService.hasPermission(this.type.toUpperCase() + ".DELETE");
      
      if(this.allFilters[this.type] !== undefined){
        this.filters = this.allFilters[this.type];
      }

      this.fieldsConfig = this.allFieldsConfig.filter(f =>
        !(f.filter === this.chips.businessId && this.type == 'worker_invoice_request') &&
        !(f.filter === this.chips.processorId && this.type == 'incoming_invoice'));
      this.syncChipsFromFilters(this.allFilters[this.type] === undefined && !this.hasFiltersInUrl);

      setTimeout(() => {
        this.allowRowSelection = false;
        if(this.type == "company_outgoing_delivery_note" && this.allowWrite){
          //acción para generar una factura que incluya los albaranes seleccionados
          this.allowRowSelection = true;
          this.topbarService.addAction("Generar factura", "",true, () => {
            this.checkDeliveryNotes();
          });
          this.topbarService.addAction("Facturar CSV", "",true, () => {
            this.csvInvoiceImport();
          });
        }else if(this.type == "incoming_invoice" && this.allowWrite){
          this.topbarService.addAction("Generar autofacturas", "",true, () => {
            this.transactionsWorker();
          });
        }else if(this.type == "outgoing_invoice_worker" && this.allowWrite){
          this.topbarService.addAction("Generar autofacturas", "",true, () => {
            this.transactionsWorkerBusiness();
          });
        }else if(this.type == "worker_invoice_request" && this.allowWrite){
          this.topbarService.addAction("Nuevo anticipo", "",true, () => {
            this.workerInvoiceRequest();
          });
        }
        
      });

      (async () => {
        await this.loadTransactionType();
        this.loadThirdParties();
        this.loadTransactionStates();
        this.loadBusinesses();
        this.loadProcessors();
      })();
    });

  }

  async loadTransactionType() {

    let params: IParamsCollection = {
      include: []
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '', this.type) }).build();

    let response = await firstValueFrom(this.transactionsTypesService.all(params));
    this.transactionType = response.data[0];
    
    this.topbarService.setTitle(this.transactionType.name);
    if(this.transactionType.enableManualCreation && this.allowWrite){
      this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
        this.edit({});
      });  
    }

    if(this.transactionType.thirdPartyType == "Company") this.thirdPartyName = "Compañía";
    if(this.transactionType.thirdPartyType == "Affected") this.thirdPartyName = "Afectado";
    if(this.transactionType.thirdPartyType == "Client") this.thirdPartyName = "Cliente";
    if(this.transactionType.thirdPartyType == "Provider") this.thirdPartyName = "Proveedor";
    if(this.transactionType.thirdPartyType == "User") this.thirdPartyName = "Tramitador";
    if(this.transactionType.thirdPartyType == "Worker") this.thirdPartyName = "Operario";
    this.allFieldsConfig[0].label = this.thirdPartyName;


    await this.loadData(this.lastGridEvent);
    
  }

  async loadThirdParties(event?: any) {
     let text = "";
    if (event != null) text = event.filter; 
    let filters = {
      name: new Filter(FilterOperation.contains, 'name', '', text),
      thirdPartyType: new Filter(FilterOperation.equals, 'thirdPartyType', '', this.transactionType.thirdPartyType)
    };

    let params: IParamsCollection = { 
      sort: ['name'],
      filter: FilterBuilder.fromObject(filters).build()
    }  
    //creamos filtros
    //params.filter = FilterBuilder.fromObject({}).build();        
    let response = await firstValueFrom(this.thirdPartiesService.all(params));    
    this.thirdParties = response.data;

    if(this.type == "affected_outgoing_budget"){
      //Si es un afectado, hay que filtrar por los afectados del caso.
      let affectedResponse = await firstValueFrom(this.affectedsService.all());
      this.thirdParties = this.thirdParties.filter((m: any) => affectedResponse.data.map((m: any) => m.id).includes(m.id));
    }
  }

  async loadTransactionStates() {
    let params: IParamsCollection = { sort: ['position']}    
    params.filter = FilterBuilder.fromObject({
      transactionTypeId: new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transactionType.id),
      active: new Filter(FilterOperation.equals, 'active', '', true)
    }).build();       
    let response = await firstValueFrom(this.transactionsStatesService.all(params));
    this.transactionStates = response.data;
    this.fillOptions(this.stateOptions, response.data);
    if(this.notPayed){
      this.filters.transactionStateId.value = this.transactionStates.filter((m: any) => m.code == "pending")[0].id;
      this.chips.transactionStateId.value = this.filters.transactionStateId.value;
      this.loadData(this.lastGridEvent);
    }
  }


  async loadBusinesses() {
    let response = await firstValueFrom(this.businessService.all());             
    this.business = response.data;
    this.fillOptions(this.businessOptions, response.data);
  }

  private fillOptions(target: FilterOption[], items: any[]) {
    target.length = 0;
    target.push(...items.map(item => ({ label: item.name, value: item.id })));
  }

  private syncChipsFromFilters(reset: boolean) {
    const f = reset ? {} as any : this.filters;
    this.chips.code.value = f.code?.value ?? null;
    this.chips.thirdPartyName.value = f.thirdPartyName?.value ?? null;
    this.chips.transactionStateId.value = f.transactionStateId?.value ?? null;
    this.chips.businessId.value = f.businessId?.value ?? null;
    this.chips.caseNumber.value = f.caseNumber?.value ?? null;
    this.chips.notificationNumber.value = f.caseNotificationNumber?.filter?.value ?? null;
    this.chips.notLinked.value = f.netSuiteId?.allowNull === true ? true : null;
    this.chips.processorId.value = f.originalProcessorId?.value ?? null;
    this.chips.dateFrom.value = this.filtersDate.dateFrom ?? null;
    this.chips.dateTo.value = this.filtersDate.dateTo ?? null;
    this.chips.dueFrom.value = this.filtersDate.paymentDuedateFrom ?? null;
    this.chips.dueTo.value = this.filtersDate.paymentDuedateTo ?? null;
  }

  private applyChips() {
    const f = this.filters;
    f.code.value = this.chips.code.value;
    f.thirdPartyId.value = null;
    f.thirdPartyName = new Filter(FilterOperation.contains, 'thirdParty.name', '', this.chips.thirdPartyName.value || null);
    f.transactionStateId.value = this.chips.transactionStateId.value;
    f.businessId.value = this.chips.businessId.value;
    f.caseNumber.value = this.chips.caseNumber.value;
    f.caseNotificationNumber.filter.value = this.chips.notificationNumber.value;
    f.netSuiteId.allowNull = this.chips.notLinked.value === true;
    f.originalProcessorId.value = this.chips.processorId.value;
    this.setFilterDate('dateFrom', this.chips.dateFrom.value);
    this.setFilterDate('dateTo', this.chips.dateTo.value);
    this.setFilterDate('paymentDuedateFrom', this.chips.dueFrom.value);
    this.setFilterDate('paymentDuedateTo', this.chips.dueTo.value);
  }

  private setFilterDate(key: string, value: Date | null) {
    if (value) this.filtersDate[key] = value;
    else delete this.filtersDate[key];
  }

  async loadData($event: any) {
    //this.filters = this.allFilters[this.type];
    if(this.allFilters[this.type] === undefined){
      this.filters = {
        code: new Filter(FilterOperation.contains, 'code'),
        thirdPartyId: new Filter(FilterOperation.equals, 'thirdPartyId'),
        transactionStateId: new Filter(FilterOperation.equals, 'transactionStateId'),
        businessId: new Filter(FilterOperation.equals, 'businessId'),
        dateFrom: new Filter(FilterOperation.greaterOrEqual, 'date'),
        dateTo: new Filter(FilterOperation.lessOrEqual, 'date'),
        caseNumber: new Filter(FilterOperation.contains, 'case.caseNumber'),
        netSuiteId: new Filter(FilterOperation.equals, 'netSuiteId', '', null),
        caseNotificationNumber: new HasFilter('case.caseNotificationNumbers', new Filter(FilterOperation.contains, 'code')),
        //processorId: new Filter(FilterOperation.equals, 'case.processorId')
        originalProcessorId: new Filter(FilterOperation.equals, 'originalProcessorId')
      };
    }
    this.applyChips();
    this.lastGridEvent = $event;

    if(this.transactionType.id){
      let params: IParamsCollection = {      
        sort: ["-date"],
        include: ['transactionState', 'thirdParty','case',  'case.contract','case.processor', 'business', 'relatedTransaction', 'caseService', 'caseService.caseNotificationNumber', 'caseNotificationNumber','originalProcessor'],
         fields: {
          //transactions: 'id,code,date,total,netSuiteId,netSuiteError,paymentDuedate,relatedTransactionId,caseNotificationNumberId,caseId,businessId,isReturn,transactionStateId,subtotal,taxAmount,transactionState' , faltan por poner todas las relacionada.
          thirdParties: "id,name,vatNumber,deleted",
          cases: 'id,caseNumber,contract,processor,contractId,companyId',
          transactionStates:'id,name,code,backgroundColor,foregroundColor,isFinal',
          businesses: 'id,name',
          caseNotificationNumbers: 'id,code',
          contracts: "id,code",
          users: "id,name",
          //originalProcessor: "id,name"
        }
      }
  
      if(typeof $event == "undefined"){
        params.page = { number: 1, size: 25 };      
      }else{
        params.page = { number: $event.first + 1, size: $event.rows };
        if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "-" : "") + $event.sortField];    
      }    
      

      this.filters.transactionTypeId = new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transactionType.id);
      if (this.filtersDate.dateFrom != null && this.filtersDate.dateFrom != "") {
        this.filters.dateFrom = new Filter(FilterOperation.greaterOrEqual, "date", "", this.filtersDate.dateFrom.toISOString());
      }else{
        delete this.filters.dateFrom;
      }
  
      if (this.filtersDate.dateTo != null && this.filtersDate.dateTo != "") {
        this.filtersDate.dateTo =  new Date(new Date(this.filtersDate.dateTo).setHours(23,59,59,999));
        this.filters.dateTo = new Filter(FilterOperation.lessOrEqual, "date", "", this.filtersDate.dateTo.toISOString());
      }else{
        delete this.filters.dateTo;
      }

      if (this.filtersDate.paymentDuedateFrom != null && this.filtersDate.paymentDuedateFrom != "") {
        this.filters.paymentDuedateFrom = new Filter(FilterOperation.greaterOrEqual, "paymentDuedate", "", this.filtersDate.paymentDuedateFrom.toISOString());
      }else{
        delete this.filters.paymentDuedateFrom;
      }
  
      if (this.filtersDate.paymentDuedateTo != null && this.filtersDate.paymentDuedateTo != "") {
        this.filters.paymentDuedateTo = new Filter(FilterOperation.lessOrEqual, "paymentDuedate", "", this.filtersDate.paymentDuedateTo.toISOString());
      }else{
        delete this.filters.paymentDuedateTo;
      }
      
      this.allFilters[this.type] = this.filters;

      //guardamos los filtros en la sesion
      this.sessionStorage.set("transactionFilters_" + this.type, this.filters);
      this.sessionStorage.set("transactionFiltersDate_" + this.type, this.filtersDate);

      //creamos filtros
      params.filter = FilterBuilder.fromObject(this.filters).build();            
  
      let response = await firstValueFrom(this.transactionsService.all(params));      
      this.transactions = response.data;      
      this.totalRecords = response.meta['total'];
      this.topbarService.setCount(this.totalRecords);
    }
 
  }

  async loadProcessors(){
      let filters = {
        'userType': new Filter(FilterOperation.equals, 'userType.code', '', 'processor')
      };
      let params:IParamsCollection = {
        filter: FilterBuilder.fromObject(filters).build()
      };
      let response = await firstValueFrom(this.usersService.all(params));
      this.fillOptions(this.processorOptions, response.data);
      this.processors = response.data;//QUe permita añadir el procesador varias vaces porque puede ser con distinto tipo de daño/porcentaje..filter((x: any) => x.id == this.contractProcessor.processorId || !this.processorsIds.some((y: any) => y == x.id));  
    }
  
  /*
  clearFilters() {
    this.filters = {};
     this.filters = {
        code: new Filter(FilterOperation.contains, 'code'),
        thirdPartyId: new Filter(FilterOperation.equals, 'thirdPartyId'),
        transactionStateId: new Filter(FilterOperation.equals, 'transactionStateId'),
        businessId: new Filter(FilterOperation.equals, 'businessId'),
        dateFrom: new Filter(FilterOperation.greaterOrEqual, 'date'),
        dateTo: new Filter(FilterOperation.lessOrEqual, 'date'),
        caseNumber: new Filter(FilterOperation.contains, 'case.caseNumber'),
        netSuiteId: new Filter(FilterOperation.equals, 'netSuiteId', '', null),
        caseNotificationNumber: new HasFilter('case.caseNotificationNumbers', new Filter(FilterOperation.contains, 'code')),
        //processorId: new Filter(FilterOperation.equals, 'case.processorId')
        originalProcessorId: new Filter(FilterOperation.equals, 'originalProcessorId')
      };
    this.filtersDate = {};
    this.search();
  }
  */

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(transaction: any) {    
    this.router.navigate(['transactions/' + this.type + '/' + (transaction && Object.keys(transaction).length > 0 ? transaction.id : 0)]);
  }

  transactionsWorker(){    
    this.router.navigate(['transactions/' + this.type + '/transactions-workers/incoming_invoice']);
  }

  transactionsWorkerBusiness(){    
    this.router.navigate(['transactions/' + this.type + '/transactions-workers-business']);
  }


  async checkDeliveryNotes(){
    if (!this.validateSelectedTransactions()) return;

    //se pueden facturar juntos albaranes de distintos contratos de la misma sociedad, pero avisamos antes
    const contracts = [...new Set(this.selectedRowsIds.map((t: any) => t.case?.contract?.code ?? 'Sin contrato'))];
    if (contracts.length > 1) {
      this.confirmationService.confirm({
        header: 'Albaranes de distintos contratos',
        message: `Los albaranes seleccionados pertenecen a ${contracts.length} contratos distintos (${contracts.join(', ')}). Se usarán los datos de facturación de uno de ellos: revise serie, forma de pago, vencimiento y cuenta bancaria antes de generar la factura. ¿Desea continuar?`,
        acceptLabel: 'Continuar',
        rejectLabel: 'Cancelar',
        icon: 'pi pi-exclamation-triangle',
        accept: () => this.openGenerateInvoice()
      });
    } else {
      this.openGenerateInvoice();
    }
  }

  openGenerateInvoice(){
      var dialog = this.dialogService.open(GenerateInvoiceComponent, {
        closable: true,
        modal: true,
        header: 'Generar factura',
        width: '400px',
        data: {
          selectedRowsIds: this.selectedRowsIds
        }
      });
      dialog.onClose.subscribe(async (result:any) => {
        this.selectedRowsIds = [];
        this.loadData(this.lastGridEvent);
      });
  }

  onSelectionChange(selection: any[]) {
    //al marcar todos, la tabla junta las filas fijadas arriba con las de la página y repite las que están en ambas
    this.selectedRowsIds = selection.filter((t: any, index: number) => selection.findIndex((s: any) => s.id === t.id) === index);
    if (!this.selectedRowsIds.length) this.selectionCollapsedByUser = null;
  }

  //mismo criterio que validateSelectedTransactions: misma compañía y misma sociedad
  isCompatibleWith(transaction: any, reference: any): boolean {
    if (reference == null) return true;
    return transaction.thirdPartyId === reference.thirdPartyId
      && (transaction.businessId ?? null) === (reference.businessId ?? null);
  }

  isSelectable(transaction: any): boolean {
    return !transaction.transactionState?.isFinal && this.isCompatibleWith(transaction, this.selectedRowsIds[0]);
  }

  isRowSelectable = (event: any): boolean => this.isSelectable(event.data);

  onHeaderCheckboxToggle(event: any) {
    //desmarcar desde la cabecera quita toda la selección, no solo la de la página actual
    if (!event.checked) this.clearSelection();
  }

  unselectTransaction(transaction: any) {
    this.selectedRowsIds = this.selectedRowsIds.filter((t: any) => t.id !== transaction.id);
    if (!this.selectedRowsIds.length) this.selectionCollapsedByUser = null;
  }

  clearSelection() {
    this.selectedRowsIds = [];
    this.selectionCollapsedByUser = null;
  }

  get selectionCollapsed(): boolean {
    return this.selectionCollapsedByUser ?? (this.selectedRowsIds.length > 3 || window.innerHeight < 800);
  }

  toggleSelectionCollapsed() {
    this.selectionCollapsedByUser = !this.selectionCollapsed;
  }

  @HostListener('window:resize')
  onWindowResize() {}

  sumSelected(field: string): number {
    return this.selectedRowsIds.reduce((total: number, t: any) => total + (t[field] ?? 0), 0);
  }

  async csvInvoiceImport(){    
    var dialog = this.dialogService.open(GenerateInvoiceCsvComponent, {
      closable: true,
      modal: true,
      header: 'Generar factura desde CSV',
      width: '1100px',
      data: {
      }
    });
    dialog.onClose.subscribe(async (result:any) => {
      this.selectedRowsIds = [];
      this.loadData(this.lastGridEvent);
    });
  }

  async loadContract(){
    //Obtenemos los datos del expediente para tener el contrato        
    this.caseSelected = await firstValueFrom(this.casesService.get(this.transactionSelected.caseId, { include: ['contract'] }));        
  }

  /*async loadPaymentData(){
    this.invoice = {};
    //Obtenemos los datos del expediente para tener el contrato            
    this.invoice.paymentDuedateDays = this.caseSelected.contract?.paymentDuedateDays;
    this.invoice.paymentMethodId = this.caseSelected.contract?.paymentMethodId;
    this.onPaymentMethodChange(this.invoice.paymentMethodId);
    this.invoice.billingCompanyBankAccountId = this.caseSelected.contract?.billingCompanyBankAccountId;
    this.invoice.date = new Date();
    //Añadimos a fecha los dias de vencimiento de contrato
    this.invoice.paymentDuedate = new Date(this.invoice.date);
    this.invoice.paymentDuedate.setDate(this.invoice.paymentDuedate.getDate() + this.caseSelected.contract?.paymentDuedateDays);       
    this.invoice.transactionSerieId = this.transactionSeries[0].id; 
  }*/
  
  /*async loadPaymentsMethods() {

    let response = await firstValueFrom(this.paymentsMethodsService.all({ page: { number: 1, size: 10 } }));
    this.paymentsMethods = response.data;

  }*/

  /*async loadBillingCompaniesBankAccounts() {

    let filters: any = {};
    if (this.transactionSelected != null && this.transactionSelected.businessId != null) {
      filters.companyId = new Filter(FilterOperation.equals, 'businessId', "", this.transactionSelected.businessId);
    }

    let params: IParamsCollection = {
      page: { size: 0 },
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.businessBankAccountsService.all(params));
    this.billingCompaniesBanksAccounts = response.data;
  }*/

  /*async loadTransactionSeries() {
    //Obtenemos el id del tipo de transacición factura de empresa
    let paramsTransactionType: IParamsCollection = {
      include: []
    }
    //creamos filtros
    paramsTransactionType.filter = FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '', "company_outgoing_invoice") }).build();

    let responseTransactionType = await firstValueFrom(this.transactionsTypesService.all(paramsTransactionType));
    let transactionTypeInvoice = responseTransactionType.data[0];

    let filters: any = {};
    if (this.caseSelected != null && this.caseSelected.contractId != null) {
      filters.contractId = new Filter(FilterOperation.equals, 'contractId', "", this.caseSelected.contractId);      
    }

    filters.transactionTypeId = new Filter(FilterOperation.equals, 'transactionSerie.transactionTypeId', "", transactionTypeInvoice.id);

    let params: IParamsCollection = {
      page: { size: 0 },
      include: ['transactionSerie'],
      filter: FilterBuilder.fromObject(filters).build()
    };
    let response = await firstValueFrom(this.contractTransactionSeriesService.all(params));
    this.transactionSeries = response.data.map((m: any) => {
      return m.transactionSerie;
    });
    this.transactionSeries.push({id: -1, name: "Sin serie"});
    
  }*/

  delete(transaction: any) {
    
    if(transaction.netSuiteId != null){
      this.messageService.add({ closable: true, severity: 'info', detail: "No se puede eliminar una transacción que ha sido contabilizada." });
      return;
    }

    if (this.allowDelete) {      
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar la transacción " + transaction.code + "?",
        header: "Eliminar transacción",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.transactionsService.delete(transaction.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Transacción eliminada correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }

  
  validateSelectedTransactions(): boolean {
    if (!this.selectedRowsIds.length) {
      this.messageService.add({ severity: 'warn', detail: 'Debe seleccionar al menos un albarán.' });
      return false;
    }
    //la selección se mantiene al cambiar de página o de filtro, así que validamos todos los albaranes
    //seleccionados y no solo los de la página actual
    const selectedTransactions = this.selectedRowsIds;

    this.transactionSelected = selectedTransactions[0];
    const firstThirdPartyId = selectedTransactions[0]?.thirdPartyId;
    const allSameThirdParty = selectedTransactions.every((t:any) => t.thirdPartyId === firstThirdPartyId);  
    if (!allSameThirdParty) {
      this.messageService.add({ severity: 'error', detail: 'Los albaranes seleccionados deben pertenecer a la misma compañía.' });
      return false;
    } 

    const businessId = selectedTransactions.filter((m: any) => m.businessId != null).map((t:any) => t.businessId);
    const firstBusinessId = businessId[0];
    if(businessId.length != 0){
  
      //const firstBusinessId = selectedTransactions[0]?.businessId;    
      const allSameBusiness = selectedTransactions.every((t:any) => t.businessId === firstBusinessId && t.businessId != null);        
  
      if (!allSameBusiness) {
        this.messageService.add({ severity: 'error', detail: 'Los albaranes seleccionados deben pertenecer a la misma sociedad.' });
        return false;
      }    
    }

    return true;
  }

  async generatePayment(transaction: any) {
    await this.loadTaxes();   
    this.transactionSelected = transaction;
    //Obtenemos una linea de la transacción para obtener el tipo de iva
    let params: IParamsCollection = {
      sort: ["lineNumber"] 
    }
    if(this.type== "incoming_invoice"){
      params.include = ["caseService", "caseService.case", "caseService.capability"];
    }
    let filters: any = {
      transactionId: new Filter(FilterOperation.equals, "transactionId"),
    };

    filters.transactionId.value = this.transactionSelected.id;
    params.filter = FilterBuilder.fromObject(filters).build();   
    
    let response = await firstValueFrom(this.transactionsLinesService.all(params));
    if(this.type == "incoming_invoice"){
      //Vamos a guardar las transacciones para mostrarlas.
      this.transactionsLinesToPayment = response.data;
    }else{
      this.transactionsLinesToPayment = [];
    }
    //por defecto seleccionamos todas las líneas
    this.selectedTransactionLinesToPayment = [...this.transactionsLinesToPayment];

    if(response.data.length > 0){
      this.payment.taxPercent = response.data[0].taxPercent;
      if( this.payment.taxPercent == null){
         this.payment.taxPercent = this.taxes.filter(m => m.code == "GENERAL")[0].percent;
      }
    }else{
      this.payment.taxPercent = this.taxes.filter(m => m.code == "GENERAL")[0].percent;    
    }

    this.displayPaymentModal = true;
    this.payment.date = new Date();
    this.payment.transactionTypeId = transaction.transactionTypeId;
    this.payment.price = transaction.subtotal;
    this.payment.total = transaction.total;       
    this.payment.isReturn = true; 
    this.payment.type = 'total';
    
    this.calculatePrices();
  }

  async generateReview(transaction: any) {

    this.loadRevisionReasons();
    await this.loadTaxes();   
    this.transactionSelected = transaction;
    //Obtenemos una linea de la transacción para obtener el tipo de iva
    
    this.payment.taxPercent = this.taxes.filter(m => m.code == "GENERAL")[0].percent;        

    this.displayReviewModal = true;
    this.payment.date = new Date();
    this.payment.transactionTypeId = transaction.transactionTypeId;        
    this.payment.total = transaction.total - transaction.companyPayedAmmount;
    this.payment.taxAmount = (this.payment.total * (this.payment.taxPercent / 100)).toFixed(2);
    this.payment.price = (this.payment.total - this.payment.taxAmount).toFixed(2);
    this.payment.isReturn = false; 
    this.payment.companyPayedAmmount = transaction.companyPayedAmmount;
    
    //this.calculatePrices();       
    

  }

  async loadRevisionReasons() {
    let params: IParamsCollection = {
      include: []
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject({ active: new Filter(FilterOperation.equals, 'active', '', true) }).build();

    let response = await firstValueFrom(this.transactionsRevisionsReasonsService.all(params));
    this.transactionRevisionReasons = response.data;

    this.transactionRevisionReasons.push({ id: -1, name: 'Otros' });
  }

  async savePayment(){
    
    if(this.payment.date == null){
      this.messageService.add({ severity: 'error', detail: 'La fecha del abono no puede ser nula.' });
      return;
    }
    if(this.payment.taxPercent == null){
      this.messageService.add({ severity: 'error', detail: 'La impuesto del abono no puede ser nulo.' });
      return;
    }
    if(this.payment.price == null){
      this.messageService.add({ severity: 'error', detail: 'La precio del abono no puede ser nulo.' });
      return;
    }

    const subtotal = Math.round(this.payment.subtotal * 100) / 100;
    const total = Math.round(this.transactionSelected.total * 100) / 100;

    if (subtotal > total) {
      this.messageService.add({ severity: 'error', detail: 'El importe del abono no puede superar el total de la factura.' });
      return;
    } 

      let data: any = {
        notes: this.payment.notes,
        transactionSelectedId: this.transactionSelected.id,
        code: this.payment.code,
        date: this.payment.date, //new Date(),
        price: this.payment.price,
        taxPercent: this.payment.taxPercent,
        taxAmount: this.payment.taxAmount,
        subtotal: this.payment.subtotal,
        transactionLinesIds: this.selectedTransactionLinesToPayment.map((line: any) => line.id),
      };

      let result: any = await firstValueFrom(this.transactionsService.generatePaymentReturn(data));

      this.messageService.add({ closable: true, severity: 'success', summary: 'Abono guardado correctamente.' });
      this.displayPaymentModal = false;
      this.loadData(this.lastGridEvent);
    
  }


  async saveReview(){ 
    if(this.payment.date == null){
      this.messageService.add({ severity: 'error', detail: 'La fecha del abono no puede ser nula.' });
      return;
    }
    if(this.payment.taxPercent == null){
      this.messageService.add({ severity: 'error', detail: 'La impuesto del abono no puede ser nulo.' });
      return;
    }
    if(this.payment.price == null){
      this.messageService.add({ severity: 'error', detail: 'La precio del abono no puede ser nulo.' });
      return;
    }

    let selectedReason = this.transactionRevisionReasons.find(
      (reason:any) => reason.id === this.payment.revisionReasonId
    );

    let notes = this.payment.revisionReasonId === -1
        ? this.payment.notes
        : selectedReason?.name || '';
    
    let data: any = {
      notes: notes,
      transactionSelectedId: this.transactionSelected.id,
      date: this.payment.date, // new Date(),
      price: this.payment.price,
      taxPercent: this.payment.taxPercent,
      taxAmount: this.payment.taxAmount,
      subtotal: this.payment.subtotal,
    };    

    let result: any = await firstValueFrom(this.transactionsService.generateReview(data));

    this.messageService.add({ closable: true, severity: 'success', summary: 'Revisión generada correctamente.' });
    this.displayReviewModal = false;
    this.loadData(this.lastGridEvent);
    
  }

  async exportTransaction(transactionType: string, transactionId: string, contractId?: string, companyId?: string){
    this.templateService.getTemplateId(transactionType, contractId, companyId, transactionId).then((result:any) => {
      if(result != null){
        this.transactionsService.export(transactionId, result.templateId, result.metadata);
      }
    });
  }


  onTransactionLinesToPaymentSelectionChange(selection: any[]) {
    this.selectedTransactionLinesToPayment = selection;

    const subtotal = this.selectedTransactionLinesToPayment.reduce((sum, line) => sum + (line.subtotal || 0), 0);
    const taxAmount = this.selectedTransactionLinesToPayment.reduce((sum, line) => sum + (line.taxAmount || 0), 0);

    this.payment.price = Math.round(subtotal * 100) / 100;
    this.payment.subtotal = this.payment.price;
    this.payment.taxAmount = Math.round(taxAmount * 100) / 100;
    this.payment.total = Math.round((subtotal + taxAmount) * 100) / 100;
  }

  calculatePrices() {
    const price = this.payment?.price || 0;
    const taxPercent = this.payment?.taxPercent || 0;
  
    // Cálculo del importe de impuestos
    this.payment.taxAmount = price * (taxPercent / 100);
  
    // Cálculo del subtotal final con impuestos
    this.payment.subtotal = price;
    this.payment.total = this.payment.subtotal + this.payment.taxAmount;
    
  }

  async loadTaxes() {
    this.loadingTaxes = true;
    let params: IParamsCollection = {
    }

    let response = await firstValueFrom(this.taxesService.all(params));
    this.taxes = response.data;

    this.loadingTaxes = false;
  }

/*
  onInvoiceDateChange(date: Date): void {
    const daysToAdd = this.invoice.paymentDuedateDays; // O cualquier valor que necesites
    if (date) {
      const dueDate = new Date(date);
      dueDate.setDate(dueDate.getDate() + daysToAdd);
      this.invoice.paymentDuedate = dueDate;
    }
  }*/
  

  /*onPaymentMethodChange(paymentMethodId: string): void {
    const selectedMethod = this.paymentsMethods.find(m => m.id === paymentMethodId);
    this.selectedPaymentMethodRequiresBank = selectedMethod?.businessBankAccountEnabled === true;
  }*/

  async workerInvoiceRequest(){
    await this.loadWorkers();
    this.displayRequestModal = true;
    this.request.date = new Date();
  }

  async loadWorkers() {
    let response = await firstValueFrom(this.workersService.all());
    this.workers = response.data;    
  } 

  async saveWorkerInvoiceRequest(){
    const subtotal = Math.round(this.payment.subtotal * 100) / 100;
    const total = Math.round(this.transactionSelected.total * 100) / 100;

    if(this.request.thirdPartyId == null){
      this.messageService.add({ severity: 'error', detail: 'Debe seleccionar un operario.' });
      return;
    }

    if(this.request.total == null || this.request.total == 0){
      this.messageService.add({ severity: 'error', detail: 'El importe del anticipo no puede ser 0.' });
      return;
    }
    
    if(this.request.date == null){
      this.messageService.add({ severity: 'error', detail: 'Debe seleccionar la fecha del anticipo.' });
      return;
    }

    let result: any = await firstValueFrom(this.transactionsService.generateWorkerInvoiceRequest(this.request));

    this.messageService.add({ closable: true, severity: 'success', summary: 'Anticipo guardado correctamente.' });
    this.displayRequestModal = false;
    this.loadData(this.lastGridEvent);
    
  }

  async generateRequest(transaction:any){
    this.router.navigate(['transactions/' + this.type + '/transactions-workers/incoming_invoice/'+transaction.id]);
  }

  async rejectRequest(transaction:any){
    this.confirmationService.confirm({
      message: "¿Está seguro que desea rechazar el anticipo "+transaction.code+"?",
      header: "Rechazar anticipo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: async () => {
        //Obtenemos el estado rejected del tipo de transacción
        let params: IParamsCollection = {
          filter: FilterBuilder.fromObject({ transactionTypeId: new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transactionType.id), code: new Filter(FilterOperation.equals, 'code', '', "rejected") }).build()
        }
        let response = await firstValueFrom(this.transactionsStatesService.all(params));
        let transactionState = response.data[0];
        if(transactionState != null){
          transaction.transactionStateId = transactionState.id;
          await firstValueFrom(this.transactionsService.save(transaction));
          
          this.messageService.add({ closable: true, severity: 'success', detail: "Anticipo rechazado correctamente" });
          this.loadData(this.lastGridEvent);      
        }
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
    
  }

  getStateTooltip(transaction:Transaction){
    let tooltip = "";
    if(transaction.payedAmmount!=null && transaction.payedAmmount > 0){
      tooltip = "Pagado " + transaction.payedAmmount + "€";
      if(transaction.payedDate!=null) tooltip += " en fecha " + transaction.payedDate?.toLocaleDateString();
    }
    return tooltip;
  }

}
